import { render, staticRenderFns } from "./PortfolioIntro.vue?vue&type=template&id=6ce600c1&"
import script from "./PortfolioIntro.vue?vue&type=script&lang=js&"
export * from "./PortfolioIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports